// src/modules/productos/composables/marcaVehiculoComposables/useMarcaVehiculosList.ts

import { computed, Ref, watch } from "vue";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import type { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import { ListMarcaVehiculoAction } from "../../actions/marcaVehiculosActions";

export function useMarcaVehiculosList(params: Ref<PaginacionFilterParams>) {
  const queryClient = useQueryClient();

  // TanStack Query principal
  const query = useQuery({
    queryKey: ["MarcaVehiculosList", params],
    queryFn: () => ListMarcaVehiculoAction(params.value),
    staleTime: 60 * 1000, // cache de 1 min
  });

  // Extraer datos en forma reactiva
  const marcas = computed(() => query.data.value?.data?.data.marcasVehiculos || [] );
  const total = computed(() => query.data.value?.data?.data?.total || 0);
  const totalPages = computed(() => query.data.value?.data?.data?.totalPages || 0);
  const currentPage = computed(() => query.data.value?.data?.data?.page || 1);

  // Prefetch cuando cambien los parámetros
  watch(params, (newParams) => {
    queryClient.prefetchQuery({
      queryKey: ["MarcaVehiculosList", newParams],
      queryFn: () => ListMarcaVehiculoAction(newParams),
    });
  }, { deep: true });

  return {
    ...query,
    marcas,
    total,
    totalPages,
    currentPage,
  };
}
